import { Divider } from '@mui/material'
import { type $Base } from 'element-domain/src/__generated/enhanced-model'
import { type Table } from 'element-domain/src/__generated/model'

import {
  AttributeCardSelector,
  AttributeToggleSelector,
  ChildEntityCardSelector,
} from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

interface BasePropertyPageProps {
  entityId: Table['id']
  base: $Base
}

export default function BasePropertyPage({ entityId, base }: BasePropertyPageProps) {
  return (
    <PropertyContainer.Section title="Base">
      <Divider sx={{ my: 2.5 }} />
      <PropertyContainer.Group spacing="large">
        <PropertyContainer.Item title="Base Type">
          <AttributeCardSelector entityId={entityId} instanceName="baseTypes" />
        </PropertyContainer.Item>

        <PropertyContainer.Item title="Base Style">
          <ChildEntityCardSelector entityId={entityId} instanceName="baseStyles" />
        </PropertyContainer.Item>

        <PropertyContainer.Item title="Cross Brace">
          <AttributeToggleSelector entityId={base.id} instanceName="hasCrossbrace" columnCount={2} />
        </PropertyContainer.Item>
      </PropertyContainer.Group>
    </PropertyContainer.Section>
  )
}
